// frontend/src/features/livestock/brandText.ts
import type { CSSProperties } from 'react';

/**
 * Teal text for subtle and light buttons that is dark enough on white:
 * --rdh-brand-on-light measures 6.3:1, where Mantine's own teal text for
 * these variants measures 4.2:1 (subtle) and 3.7:1 (light). Pass as `style`
 * (it overrides the variant's colour variable; disabled buttons keep theirs).
 */
export const BRAND_TEXT = { '--button-color': 'var(--rdh-brand-on-light)' } as CSSProperties;
